import React from 'react';
import DateHelper from '../DateHelper/DateHelper';
import numeral from "numeral";
import I18n from 'i18n-js';
import DataTable from '../DataTable/DataTable'
import Switch from "../Switch/Switch";
import { differenceInDays } from 'date-fns';
import CurrencyInput from '../CurrencyInput/CurrencyInput';
import ReservationBuilderActions from './actions/ReservationBuilderActions';

export default class ReservationBuilderSegmentSummary extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dateFormat: DateHelper.rubyToDateFNS(this.props.date_format),
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',

      open: this.props.open,

      discount_amount: this.props.discount_amount || null,
      discount_percentage: this.props.discount_percentage || null,
      discount_number_of_nights: this.props.discount_number_of_nights || null,
      discountOpen: false,
      discountLoading: false,
      discountError: null,

      promotionCode: this.props.segment && this.props.segment.promotion ? this.props.segment.promotion.code : '',
      promotionOpen: false,
      promotionLoading: false,
      promotionError: null,
    };
  };

  componentDidUpdate() {
    var self = this;

    if (this.refs.promo_select) {

      if ($(this.refs.promo_select).data('select2')) {
        return;
      }

      $(this.refs.promo_select).select2({
        ajax: {
          url: '/admin/promotions_remote',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page,
              results_per_page: 40
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;

            return {
              results: data.items,
              pagination: {
                more: (params.page * 40) < data.total_count
              }
            };
          },
          cache: true
        },
        allowClear: true,
        escapeMarkup: function (markup) {
          return markup;
        },
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (promo) {
          if (promo.loading) {
            return promo.text;
          }

          return self.processPromo(promo);
        },
        templateSelection: function (promo) {
          if (promo && promo.id != null && promo.id != '') {
            self.setState({promotionCode: promo.code});
          }

          return self.processPromo(promo);
        }
      }).on('select2:unselect', function () {
        self.setState({promotionCode: null});
      });
    }
  }

  render() {
    var segment = this.props.segment;
    var billing_policy = this.props.segment.rate.billing_policy;
    var products = this.renderProducts(segment.rate)
    var number_of_nights = differenceInDays(segment.check_out_date, segment.check_in_date)

    return (
      <div className="reservation-segment expanded" ref="reservation_segment" key={segment.id}>
        <div className="header">

          <div className="flexed segment-price-details-wrapper">
            <span className="seg-details-wrapper">
              {!this.props.open ? this.renderArrow() : null}
              {DateHelper.printDateToScreen(segment.check_in_date, this.state.dateFormat)} &ndash; {DateHelper.printDateToScreen(segment.check_out_date, this.state.dateFormat)}  ({number_of_nights} {number_of_nights > 1 ? I18n.t('nights') : I18n.t('night')}, {segment.number_of_guests} {segment.number_of_guests > 1 ? I18n.t('guests') : I18n.t('guest')}): &nbsp;
              <strong><a href={`/admin/room_types/${this.props.segment.room_type.id}`} className="modal-iframe" data-fullscreen="true">{segment.room_type.name}</a> (<a href={`/admin/rates/${segment.rate.id}`} className="modal-iframe" data-fullscreen="true">{segment.rate.code}</a>)</strong>&nbsp;
            </span>
            <div className="seg-price-wrapper" >
              <div>{segment.subtotal_amount ? ' $' + numeral((segment.subtotal_amount - segment.add_ons_subtotal_amount) / 100).format(this.state.numberFormat) : null}</div>
            </div>
          </div>
          <div>
            {this.renderAddOns(segment)}
          </div>
          {
            segment.rate.rate_products && segment.rate.rate_products.length
              ?
            <div style={{fontStyle: 'italic', marginLeft: '21px', fontSize: '12px'}}>
              <label>{I18n.t('includes')}:</label>
              <ul>
                {products}
              </ul>
            </div>
              :
            null
          }
        </div>
        {
          this.props.edit_segment
            ?
          <table>
            <tbody>
            <tr>
              <td><label>{I18n.t('check_in_date')}:</label></td>
                <td><div className="value">{DateHelper.printDateToScreen(segment.check_in_date, this.state.dateFormat)}</div></td>
            </tr>
            <tr>
              <td><label>{I18n.t('check_out_date')}:</label></td>
                <td><div className="value">{DateHelper.printDateToScreen(segment.check_out_date, this.state.dateFormat)}</div></td>
            </tr>
            <tr>
              <td><label>{I18n.t('number_of_nights')}:</label></td>
                  <td><div className="value">{differenceInDays(segment.check_out_date, segment.check_in_date)}</div></td>
            </tr>
            <tr>
              <td><label>{I18n.t('number_of_guests')}:</label></td>
              <td><div className="value">{segment.number_of_guests}</div></td>
            </tr>
            <tr>
              <td colSpan="2">
              </td>
            </tr>
            <tr>
              <td><label>{I18n.t('rate')}:</label></td>
              <td><div className="value">{segment.rate.code} <small style={{position: 'relative', top: -1, left: 11}}><a href={`/admin/billing_policies/${billing_policy.id}`} className="modal-iframe" data-fullscreen="true">{I18n.t('view_billing_policy')}</a></small></div></td>
            </tr>
            <tr>
              <td><label>{I18n.t('room_subtotal')}:</label></td>
              <td><div className="value">${numeral(segment.subtotal_amount / 100).format(this.state.numberFormat)}</div></td>
            </tr>
            <tr style={{display: this.props.segment && this.props.segment.add_ons_amount ? 'table-row' : 'none'}}>
              <td><label>{I18n.t('add_ons')}:</label></td>
              <td><div className="value">${numeral(this.props.segment.add_ons_amount / 100).format(this.state.numberFormat)}</div></td>
            </tr>
            <tr>
              <td colSpan="2"><hr /></td>
            </tr>
            <tr className="total-charged">
              <td style={{paddingBottom: 0}}><label>{I18n.t('room_total')}:</label></td>
              <td style={{paddingBottom: 0}}><div className="value">${numeral(segment.total_amount / 100).format(this.state.numberFormat)}</div></td>
            </tr>
            </tbody>
          </table>
            :
            this.renderFoloItemsTable(segment)
          
        }

      </div>
    );
  }

renderFoloItemsTable = (segment) => {  
  if(this.state.open){
    return(
      <div className="body" ref="body">
        <div className='flexed data-table-due-today-wrapper'>
          <div className='col-md'>
            <DataTable
              endpoint={this.props.edit_reservation_segment_folio_items_data_table_path ? this.props.edit_reservation_segment_folio_items_data_table_path : `/admin/reservation-segments/${segment.temp_id}/booking-folio-items/data-table`}
              reservation={this.props.reservation}
              no_data_text={I18n.t('none')}
              currency_unit={I18n.t('number.currency.format.unit')}
              delimiter={I18n.t('number.currency.format.delimiter')}
              separator={I18n.t('number.currency.format.separator')}
              date_format={this.props.date_format}
              time_format={this.props.time_format}
              read_only={this.props.read_only} />
          </div>
     
          <div className='col-md-2 flexed segment-sumary-due-today-wrapper'>
            {
              this.props.edit_reservation_segment_folio_items_data_table_path
              ?
              <div>
                <label>{I18n.t("accept_updated_folio?")} <span className="ss-help help" title={I18n.t('accept_updated_folio_helper_text')}></span></label>
                <Switch onText="yes" switchId="accept-updated-folio" offText="no" name="accept_updated_folio" value={this.props.accept_updated_folio ? this.props.accept_updated_folio  : false} onChange={this.props.onChangeAcceptUpdatedFolio}  />
              </div>
              :
              <div className='form-group'>
                <label>{I18n.t('due_today')}</label>
                <CurrencyInput value={segment.booking_payment_amount} id={segment.id} name="amount_due_at_booking" onBlur={this.onBlurBookingPaymentAmount} min={0} onChangeEventType={true} />
              </div>
            }
          </div>
        </div>
      </div>
    );
  };
};

  renderTaxes(segment){
    var taxes = []
    return taxes
  };

  renderAddOns(reservation_segment) {
    var self = this;
    var add_ons = []
    if (reservation_segment.reservation_segment_add_ons && self.props.products) {
      for (var i = 0, ilen = reservation_segment.reservation_segment_add_ons.length; i < ilen; i++) {
        var reservation_segment_add_on = reservation_segment.reservation_segment_add_ons[i];

        for (var j = 0, jlen = self.props.products.length; j < jlen; j++) {
          var product = self.props.products[j];
          if (product.id === reservation_segment_add_on.product_id) {
            var quantity = reservation_segment_add_on.quantity
            add_ons.push(
              <tr key={product.id}>
                <td className="segemnt-add-on-name-td">{product.name}{quantity > 1 ? <span> &times; {quantity}</span> : ''}</td>
                <td className="text-right segment-add-on-amount-td">{self.props.currency.symbol}{numeral(reservation_segment_add_on.subtotal_amount * self.props.currency.exchange_rate / 100).format(self.state.numberFormat)}</td>
              </tr>
            );
          };
        };
      };
    };

    if (add_ons && add_ons.length) {
      return (
        <table className="add-ons-table">
          <tbody>
            {add_ons}
          </tbody>
        </table>
      )
    } else {
      return null
    };
  };

  renderArrow() {
    if (this.state.open) {
      return (
        <div className="toggle-arrow arrow-down" onClick={this.onOpenClose}></div>
      );
    } else {
      return (
        <div className="toggle-arrow arrow-right" onClick={this.onOpenClose}></div>
      );
    };
  };

  renderProducts(rate) {
    var products = []
    if (rate.rate_products && rate.rate_products.length) {
      rate.rate_products.map((rate_product) => {
        products.push(
          <li key={rate_product.name}>{rate_product.quantity} {rate_product.name}</li>
        );
      });
    };
    return products;
  };

  onOpenClose=() => {
    this.setState({open: !this.state.open});
  };

  onBlurBookingPaymentAmount = (e) => {
    ReservationBuilderActions.changeBookingPaymentAmount(e.target.value, e.target.id);
  };

};
